import React, { useEffect, useState } from "react";
import {
  Flex, Menu, MenuButton, Heading, MenuList, MenuItem, MenuDivider, Avatar, Button, Image, Tooltip, Badge, Box, Text, Spinner,
  useDisclosure, ModalBody, ModalContent, ModalOverlay, ModalHeader, ModalCloseButton, Table, Thead, Tbody, Th, Td, Tr, Modal,
} from "@chakra-ui/react";
import { BellIcon, EditIcon } from "@chakra-ui/icons";
import DummyProfile from '../../assets/Images/Hacker-Profile-Image.svg';
import ArrowIcon from '../../assets/Images/Arrow-icon.svg';
import { NavLink } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import * as routesNames from "../../constant/routes";
import { baseUrl } from "../../hooks/useFetch";
import { showDate, showTime } from "../../utilities/helper";
const Navbar = () => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const { logout, userName } = useAuth();
  const [notificationsLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [selectedType, setSelectedType] = useState("");
  const [notificationDetails, setNotificationDetails] = useState<any[]>([]);
  const [selectedLeadId, setSelectedLeadId] = useState<number | null>(null);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [isFollowUpEditOpen, setIsFollowUpEditOpen] = useState(false);
  const [isMeetingEditOpen, setIsMeetingEditOpen] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [notificationData, setNotificationData] = useState({
    todayPendingFollowups: 0,
    todayMeetings: 0,
    overdueFollowups: 0,
    overdueMeetings: 0,
    totalNotifications: 0,
  });

  const formatMeetingDate = (date: string) => {
    if (!date) return "-";

    const [year, month, day] = date.split("T")[0].split("-");
    return `${day}-${month}-${year}`;
  };
  // const notifications = [{ message: "New lead assigned to you", }, { message: "Company updated successfully", },
  // { message: "New report generated", },
  // ];
  const { loginObj } = useAuth();

  const handleLogout = () => {
    logout();
  };

  // const fetchNotifications = async () => {
  //   try {
  //     const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //     const response = await fetch(
  //       `${baseUrl}Notification?timeZone=${encodeURIComponent(timezone)}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${loginObj?.token || ""}`,
  //         },
  //       }
  //     );

  //     const data = await response.json();

  //     setNotificationData(data);
  //   } catch (error) {
  //     console.error("Notification Error:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchNotifications();

  //   const interval = setInterval(fetchNotifications, 60000);

  //   return () => clearInterval(interval);
  // }, []);

  const notifications = [
    notificationData.todayPendingFollowups > 0 && {
      type: "todayfollowups",
      message: `${notificationData.todayPendingFollowups} pending reminder(s) today`,
      icon: "📞",
    },

    notificationData.todayMeetings > 0 && {
      type: "todaymeetings",
      message: `${notificationData.todayMeetings} meeting(s) scheduled today`,
      icon: "📅",
    },

    notificationData.overdueFollowups > 0 && {
      type: "overduefollowups",
      message: `${notificationData.overdueFollowups} overdue reminder(s)`,
      icon: "⚠️",
    },

    notificationData.overdueMeetings > 0 && {
      type: "overduemeetings",
      message: `${notificationData.overdueMeetings} overdue meeting(s)`,
      icon: "🚨",
    },
  ].filter(Boolean);


  // const loadNotificationDetails = async (type: string) => {
  //   try {
  //     setDetailsLoading(true);
  //     const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //     const response = await fetch(
  //       `${baseUrl}Notification/NotificationDetails?type=${type}&timeZone=${encodeURIComponent(timezone)}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${loginObj?.token || ""}`,
  //         },
  //       }
  //     );

  //     const data = await response.json();

  //     setNotificationDetails(data);
  //     setSelectedType(type);
  //     onOpen();
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setDetailsLoading(false);
  //   }
  // };

  return (
    <>
      <Flex h="50px" align="center" px={6} justifyContent="flex-end" bg="#FFFFFF" pt={2}>
        <Flex align="center" gap={5}>
          {/* NOTIFICATION */}
          {/* <Menu>
            <Tooltip label="Notifications" placement="bottom">
              <MenuButton as={Button} variant="ghost" position="relative" p={0} minW="unset" h="40px" w="40px" borderRadius="full" bg="#F5F5FA" _hover={{ bg: "#ECECF3" }}>
                <BellIcon boxSize={5} color="#6B7280" />

                {notificationData.totalNotifications > 0 && (
                  <Badge
                    colorScheme="red"
                    borderRadius="full"
                    position="absolute"
                    top="-2px"
                    right="-2px"
                    fontSize="10px"
                  >
                    {notificationData.totalNotifications}
                  </Badge>)}
              </MenuButton>
            </Tooltip>

            <MenuList
              w="360px"
              maxH="300px"
              overflowY="auto"
              borderRadius="14px"
              border="1px solid #E5E7EB"
              boxShadow="0px 10px 30px rgba(0,0,0,0.08)"
            >
              {notificationsLoading ? (
                <Flex justify="center" py={4}>
                  <Spinner />
                </Flex>
              ) : notifications.length === 0 ? (
                <Box p={4}>
                  <Text textAlign="center" color="gray.500">
                    No new notifications
                  </Text>
                </Box>
              ) : (
                notifications.map((n: any, idx) => (
                  <MenuItem
                    key={idx}
                    py={3}
                    borderRadius="10px"
                    _hover={{ bg: "#F9FAFB" }}
                    onClick={() => loadNotificationDetails(n.type)}
                  >
                    <Text fontSize="14px" fontWeight="500">
                      {n.icon} {n.message}
                    </Text>
                  </MenuItem>
                ))
              )}
            </MenuList>
          </Menu> */}

          {/* DIVIDER */}
          <Box h="42px" w="1px" bg="#E5E7EB" />

          {/* PROFILE */}
          <Menu>
            <MenuButton as={Button} variant="ghost" p={0} _hover={{ bg: "transparent" }} _active={{ bg: "transparent" }} rightIcon={<Image src={ArrowIcon} />}>
              <Flex align="center" gap={3}>
                <Avatar size="sm" src={avatarUrl || DummyProfile} />

                <Text fontFamily="inter" fontSize="18px" fontWeight="500" color="#111827">
                  {userName}
                </Text>
              </Flex>
            </MenuButton>

            <MenuList borderRadius="14px">
              <MenuItem
                as={NavLink}
                to={routesNames.PROFILE}
              >
                Profile
              </MenuItem>

              <MenuDivider />
              <MenuItem
                as={NavLink}
                to={routesNames.UpdatePassword}
              >
                Update Password
              </MenuItem>
              <MenuDivider />
              <MenuItem onClick={handleLogout}>
                Logout
              </MenuItem>
            </MenuList>
          </Menu>

        </Flex>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />

        <ModalContent  maxH="600px" overflowY="auto">
          <ModalHeader>
            {selectedType === "todaymeetings" && "Today's Meetings"}
            {selectedType === "overduemeetings" && "Overdue Meetings"}
            {selectedType === "todayfollowups" && "Today's Reminders"}
            {selectedType === "overduefollowups" && "Overdue Reminders"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={5} >
            {detailsLoading ? (
              <Spinner />
            ) : (
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th >S. No.</Th>
                    <Th>Lead Name</Th>
                    <Th>Email</Th>
                    <Th>Number</Th>
                    <Th>Title / Description</Th>
                    <Th>Date</Th>
                    <Th>Time</Th>
                    <Th>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {notificationDetails.map((item: any, index: number) => (
                    <Tr key={item.id}>
                      <Td>{index + 1}</Td>
                      <Td>{item.pocname}</Td>
                      <Td>{item.pocemail}</Td>
                      <Td>{item.pocNUMBER}</Td>

                      <Td
                        dangerouslySetInnerHTML={{
                          __html: item.meetingTitle || item.description || "",
                        }}
                      />
                      <Td>
                        {item.meetingDate
                          ? item.isAllDay
                            ? formatMeetingDate(item.meetingDate)
                            : showDate(item.startDateTime)
                          : showDate(item.followTime)}
                      </Td>

                      <Td>


                        {item.meetingDate
                          ? item.isAllDay
                            ? "-"
                            : showTime(item.startDateTime)
                          : showTime(item.followTime)}
                      </Td>
                      <Td>
                        <EditIcon
                          cursor="pointer"
                          color="#4048D6"
                          onClick={() => {
                            setSelectedLeadId(item.leadId);
                            setSelectedId(item.id);
                            onClose();
                            if (selectedType === "todayfollowups" || selectedType === "overduefollowups") {
                              setIsFollowUpEditOpen(true);
                            } else {
                              setIsMeetingEditOpen(true);
                            }
                          }}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

    </>

  );
};

export default Navbar;